import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@devforce/tds-react';
import {t} from 'lib/I18n';
import { get } from '@devforce/trailhead-client-env';

export default class NextChallengeButton extends React.Component {
  static propTypes = {
    nextChallenge: PropTypes.object.isRequired,
    unitType: PropTypes.string
  }

  config() {
    const { nextChallenge, unitType } = this.props;

    if (nextChallenge.next_challenge) {
      return {
        header: null,
        description: null,
        href: nextChallenge.next_challenge.url,
        label: this.nextChallengeButtonLabel(unitType),
      };
    }

    if (nextChallenge.next_parent) {
      return {
        header: null,
        description: null,
        href: nextChallenge.next_parent.url,
        label: this.nextChallengeButtonLabel('module'),
      };
    }

    if (nextChallenge.next_trailmix_item) {
      return {
        header: null,
        description: null,
        href: nextChallenge.next_trailmix_item.url,
        label: t('reward.button.trailmix'),
      };
    }

    return {
      header: t('reward.encourage'),
      description: t('reward.button.explore_more_description'),
      href: nextChallenge.all_parents.url,
      label: t('reward.button.explore_more'),
    };
  }

  nextChallengeButtonLabel(unitType) {
    switch (unitType) {
      case 'module':
      case 'project':
        return get('USE_BADGE_LABELS') ? t('reward.button.badge') : t(`reward.button.${unitType}`);
      default:
        return t(`reward.button.${unitType}`);
    }
  }

  render() {
    const { href, label } = this.config();

    const navigateTo = () => {
      window.location.assign(href);
    };

    return (
      <Button
        label={label}
        onClick={navigateTo}
        variant="brand"
      />
    );
  }
}
